import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { AuthService } from '../../core/services/auth/auth.service';
import { ApiConfigService } from '../../ssr-services/api-config/api-config.service';

@Injectable({
  providedIn: 'root',
})
export class AccountDeletionService {
  protected http = inject(HttpClient);

  protected apiConfig = inject(ApiConfigService);

  protected authService = inject(AuthService);

  constructor() {}

  /**
   * Sends deletion otp to user's email
   * @returns
   */
  public requestDeletionOtp(): Observable<{ message: string }> {
    return this.http.post<{ message: string }>(this.apiConfig.url('subscriber/delete/otp'), {});
  }

  /**
   * Deletes the account
   * @param otp
   * @param deletionReason
   * @returns
   */
  public deleteAccount(otp: string, deleteReason: string): Observable<{ message: string }> {
    return this.http
      .post<{ message: string }>(this.apiConfig.url('subscriber/delete/otpVerify'), {
        otp,
        deleteReason,
      })
      .pipe(
        map((result) => {
          this.authService.clearTokenState();
          return result;
        })
      );
  }
}
